import { observer } from 'mobx-react-lite';
import React from 'react';
import { AppProps } from './App';
import { lowerMessageInfoMenu, raiseMessageInfoMenu } from '../stores/styleStore';
import SubviewButton from './SubviewButton';
import AttachDownloadButton from './AttachDownloadButton';
import LoadMore from './LoadMore';

const MessageInfoMenu = observer((props: AppProps) => {
    const {state, styles} = props;
    const subview = state.currentMessage.subview;
    return (
        <div className={styles.get('message-info.menu').classNames}>
            <div className="flex-mother p-7px h-60px flex-shrink-0 bb-1px-hl">
                <div className="flex-mother-col">
                    <div className="flex-1" />
                    <button className={styles.get('message-info.raiseButton').classNames} onClick={e => raiseMessageInfoMenu(styles)}><i className="arrow-up" /></button>
                    <button className={styles.get('message-info.lowerButton').classNames} onClick={e => lowerMessageInfoMenu(styles)}><i className="arrow-down" /></button>
                    <div className="flex-1" />
                </div>
                <div className="flex-mother-col flex-1">
                    <div className="flex-1" />
                    <span className="textHeader nav-accent ellipsis">{state.currentMessage.subject}</span>
                    <div className="flex-1" />
                </div>
                <SubviewButton state={state} subview={'plaintext'} />
                <SubviewButton state={state} subview={'html'} />
                <SubviewButton state={state} subview={'headers'} />
                <SubviewButton state={state} subview={'mime'} />
                <SubviewButton state={state} subview={'rawHtml'} />
                <SubviewButton state={state} subview={'attach'} />
            </div>
            <div className={styles.get('message-info.lowerButton').classNames.includes('hidden')?'overflow-auto': 'overflow-auto p-7px'}>
                {subview === 'plaintext'?<>
                    <div className="plaintext">{state.currentMessage.plaintext}</div>
                </>:''}
                {subview === 'html'?<>
                    <div className="flex-1" dangerouslySetInnerHTML={{__html: state.currentMessage.renderHtml}} />
                </>:''}
                {subview === 'headers'?<>
                    {state.currentMessage.headers!== undefined ? Object.keys(state.currentMessage.headers).map((key, ix) => {
                        return <div className="mb-3px" key={key}><b>{key.toUpperCase()}:</b> {state.currentMessage.headers![key]?.at(0)?.value}</div>;
                    }):'' }
                </>:''}
                {subview === 'mime'?
                    <LoadMore content={state.currentMessage.mime} state={state}/>
                :''}
                {subview === 'rawHtml'?
                    <div className="plaintext" contentEditable="true" spellCheck="false" suppressContentEditableWarning={true}>{state.currentMessage.html}</div>
                :''}
                {subview === 'attach'?
                    state.currentMessage.attachments.nodeList.map((node) => {
                        return <AttachDownloadButton node={node} />;
                    })
                :''}
            </div>
        </div>
    );
});

export default MessageInfoMenu;